"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _Accordion = _interopRequireDefault(require("@commerce-ui/core2/Accordion"));
var _ShowHide = _interopRequireDefault(require("@commerce-ui/core2/ShowHide"));
var _Button = _interopRequireDefault(require("@commerce-ui/core2/Button"));
var _Checkbox = _interopRequireDefault(require("@commerce-ui/core2/Checkbox"));
var __jsx = _react["default"].createElement;
var ChevronDownIcon = function ChevronDownIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.923 10.263l.848-.849 5.576 5.576 5.576-5.576.848.849-6.424 6.424-6.424-6.424z"
  }));
};
ChevronDownIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var ChevronUpIcon = function ChevronUpIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.35 8.07l6.42 6.42-.85.85-5.57-5.58-5.58 5.58-.85-.85z"
  }));
};
ChevronUpIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var VerticalMenuWithContentToggle = function VerticalMenuWithContentToggle(props) {
  var label = props.label,
    element = props.element,
    initialOpen = props.initialOpen,
    setActiveCookieList = props.setActiveCookieList,
    setAgreementsState = props.setAgreementsState,
    agreements = props.agreements,
    checkboxSelectable = props.checkboxSelectable;
  var translations = {
    thirdPartyCookies: (0, _langLibrary["default"])("Third party cookies"),
    alwaysActive: (0, _langLibrary["default"])("Always active"),
    cookieNotice: (0, _langLibrary["default"])("Cookie notice")
  };
  return __jsx(_Accordion["default"], {
    sx: {
      minWidth: "100%"
    }
  }, __jsx(_Accordion["default"].Section, {
    isOpenAtInit: initialOpen
  }, __jsx(_Button["default"], {
    sx: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      pt: 17,
      pb: 13,
      width: "100%",
      color: "main",
      px: 20,
      ":focus": {
        outline: 0,
        boxShadow: "none"
      },
      "::-moz-focus-inner": {
        border: 0
      }
    }
  }, function (_ref) {
    var selected = _ref.selected;
    return __jsx(_react["default"].Fragment, null, __jsx(_Box["default"], {
      sx: {
        font: "base_sans_bold"
      }
    }, label), __jsx(_Box["default"], null, selected ? __jsx(ChevronUpIcon, null) : __jsx(ChevronDownIcon, null)));
  }), __jsx(_ShowHide["default"], null, __jsx(_Box["default"], {
    key: element.label
  }, __jsx(_Box["default"], {
    key: "label-".concat("element.label"),
    sx: {
      font: "base",
      justifyContent: "space-between",
      display: "flex"
    }
  }), __jsx(_Box["default"], {
    sx: {
      font: "s",
      mt: 10,
      px: 20,
      pb: 20
    }
  }, __jsx(_Box["default"], {
    sx: {
      width: 120,
      "float": "right",
      p: 15,
      textAlign: "center",
      color: "active",
      font: "s_sans_bold"
    },
    onClick: function onClick() {
      agreements[element.id] = !agreements[element.id];
      setAgreementsState(agreements);
    }
  }, element.checkboxClickable ? __jsx(_Checkbox["default"], {
    sx: {
      justifyContent: "center"
    }
  }, /*#__PURE__*/_react["default"].cloneElement(checkboxSelectable, {
    label: " "
  })) : __jsx(_Box["default"], null, translations.alwaysActive)), element.text, __jsx(_Box["default"], {
    sx: {
      mt: 20,
      font: "xs_underline",
      cursor: "pointer"
    },
    onClick: function onClick() {
      setActiveCookieList(element.id);
    }
  }, translations.thirdPartyCookies), __jsx(_Box["default"], {
    sx: {
      font: "s",
      justifyContent: "space-between",
      display: "flex",
      mt: "s8",
      a: {
        display: "contents"
      }
    },
    dangerouslySetInnerHTML: {
      __html: translations.cookieNotice
    }
  }))))), __jsx(_Box["default"], {
    sx: {
      height: "1px",
      bg: "neutral"
    }
  }));
};
VerticalMenuWithContentToggle.defaultProps = {
  initialOpen: false
};
var _default = VerticalMenuWithContentToggle;
exports["default"] = _default;